import React, { useState, useRef, useEffect } from 'react';
import { Grow, Slide, Fade } from '@quillbot/design-system';

const LoadWithAnimation = (props: {
  animationType: string;
  // direction?: 'left' | 'right' | 'up' | 'down';
  children: React.ReactElement;
}) => {
  const animationComp: { [key: string]: typeof Grow | typeof Slide | typeof Fade } = {
    grow: Grow,
    slider: Slide,
    fade: Fade,
  };
  const AnimationComponent = animationComp[props.animationType] || Slide;
  const [isVisible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const isInViewport = (offset = -200) => {
    const currentNode = ref?.current;
    if (!currentNode) return false;
    if (currentNode.getBoundingClientRect) {
      const top = currentNode.getBoundingClientRect().top;
      return top + offset >= 0 && top - offset <= window.innerHeight;
    }
    return false;
  };
  const onScroll = () => {
    const eleVisible = isInViewport();
    if (eleVisible) {
      setVisible(true);
      window.removeEventListener('scroll', onScroll);
    }
  };
  useEffect(() => {
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (isVisible) {
    return (
      <AnimationComponent
        in
        mountOnEnter
        unmountOnExit
        // Animation type Slide not used now
        // direction={props.direction || 'right'}
        timeout={1000}
      >
        {props.children}
      </AnimationComponent>
    );
  }

  return <div ref={ref} />;
};

export default LoadWithAnimation;
